<div class="flex flex-row flex-auto gap-4">
  <ng-template redMetabaseParameterContainer></ng-template>
</div>
